import React from "react";
import { useNavigate } from "react-router-dom";
import "./HeroSection.css";
import { useIndependenceDayTheme } from "../../../lib/useIndependenceDayTheme";
import IndependenceDayHeroCard from "../../independence-day/IndependenceDayHeroCard";

const HeroSection1 = () => {
  const navigate = useNavigate();

  /* Independence Day only. Off the festival date this is false and the hero
   * renders exactly as it always has — no overlay DOM, no extra class. */
  const idDay = useIndependenceDayTheme();

  return (
    <div className="hero-section-wrapper">
      {idDay && <IndependenceDayHeroCard />}

      <div className="home-hero-content">

        {/* <p className="home-hero-tagline">
          Smart Vehicle Tracking Solutions
        </p> */}

        {/* <h1 className="home-hero-title">
          INDIA'S NO.1 WAY4TRACK <span>AIS-140,VLTD</span> DEVICES
        </h1> */}

        {/* <h1 className="home-hero-title">
          India’s No.1 WAY4TRACK <span>AIS140,VLTD</span> GPS Devices
        </h1> */}

        <h1 className="home-hero-title">
          Best GPS Tracking Device in India <span>| Fleet Management System</span>
        </h1>

        {/* <p className="home-hero-description">
          At <span>WAY4TRACK</span>, we believe technology should simplify lives.
          Our <span>AIS 140</span> compliant <span>GPS</span> tracking systems ensure safety,
          compliance, and real-time visibility across India.
        </p> */}
        <p className="home-hero-description">
          At <span>WAY4TRACK</span>, we believe technology becomes meaningful
          only when it makes life{" "}
          <span className="home-hero-description-simpler">SIMPLER,</span>{" "}
          <span className="home-hero-description-safer">SAFER</span> &{" "}
          <span className="home-hero-description-better">BETTER</span> for everyone.
        </p>

        <div className="home-hero-buttons">
          <button
            onClick={() => { navigate("/products"); window.scrollTo(0, 0) }}
            className={idDay ? "primary-btn w4t-id-cta" : "primary-btn"}>Explore Now</button>
          {/* <button className="secondary-btn">Explore Devices</button> */}
        </div>
      </div>

      <div className="home-hero-image-wrapper">
        <img
          src="/images/Way4track-AIS140-VLTD-Best-GPS-Device-in-India-With-Real-Time-Live-Monitoring.png"
          alt="Way4track-AIS140-VLTD-Best-GPS-Device-in-India-With-Real-Time-Live-Monitoring  "
          className="home-hero-image"
        />
      </div>

    </div>
  );
};

export default HeroSection1;